// src/ui/shell/AddPhotosSheet.tsx (T1): the phone tab bar's Add Photos sheet: Take Photo (the camera) and Choose
// from Library (several at once), each a native file picker. The files go to `onFiles`; T5's upload queue takes
// it from there (resize, upload, then Sort). Root class: hb-add-photos. On a phone each row is its title alone (the
// sub-lines stay on wider screens).
import { Icon } from "../Icon";
import { isPhone } from "../media";
import { Sheet } from "../Sheet";

export const PHOTO_ACCEPT = "image/jpeg,image/png,image/webp,image/heic,image/heif,.heic,.heif";

export function AddPhotosSheet(props: {
  open: boolean;
  onClose: () => void;
  onFiles: (files: File[], origin: "camera" | null) => void;
  /** "We'll suggest a room for each one. You decide." */
  note?: string;
}) {
  const pick = (origin: "camera" | null) => (e: Event) => {
    const input = e.currentTarget as HTMLInputElement;
    const files = Array.from(input.files ?? []);
    input.value = "";
    if (files.length === 0) return;
    props.onClose();
    props.onFiles(files, origin);
  };
  return (
    <Sheet open={props.open} onClose={props.onClose} title="Add Photos" class="hb-add-photos add-sheet">
      <p class="as-note">{props.note ?? (isPhone.value ? "We'll suggest a room. You decide." : "We'll suggest a room for each one. You decide.")}</p>
      <div class="as-rows" role="group" aria-label="Add photos from">
        <label class="as-row">
          <span class="as-ic" aria-hidden="true">
            <Icon name="camera" />
          </span>
          <span>
            <b>Take Photo</b>
            <span class="as-sub">Use your phone's camera</span>
          </span>
          <Icon name="chev-r" />
          <input class="sr" type="file" accept="image/*" capture="environment" onChange={pick("camera")} />
        </label>
        <label class="as-row">
          <span class="as-ic" aria-hidden="true">
            <Icon name="image" />
          </span>
          <span>
            <b>Choose from Library</b>
            <span class="as-sub">Pick several at once</span>
          </span>
          <Icon name="chev-r" />
          <input class="sr" type="file" accept={PHOTO_ACCEPT} multiple onChange={pick(null)} />
        </label>
      </div>
    </Sheet>
  );
}
